import { styled, Tab, Tabs } from "@mui/material";
import PropTypes from "prop-types";
import { useState } from "react";
import NativeFilter from "../../../components/NativeFilter/NativeFilter";
import TabPanel from "../../../components/TabPanel/TabPanel";

const LayoutWrapper = styled("div")({
  alignItems: "stretch",
  display: "flex",
  flexDirection: "column",
  height: "100%",
  justifyContent: "space-evenly",
  width: "100%",
});

function ConjuntosBasket({ app, config, index }) {
  const [activeTab, setActiveTab] = useState(index);
  const { tabs } = config.basket.container[0].cards[0].modal.conjuntos;
  const handleSecondTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <LayoutWrapper>
      {/* <FilterMenuModal app={app} filters={config.app?.filters || {}} /> */}
      <div style={{ display: "flex", marginBottom: "24px" }}>
        <Tabs
          value={activeTab}
          onChange={handleSecondTabChange}
          style={{ width: "100%", display: "inline-block" }}
        >
          <Tab
            label={tabs[0].label}
            id={`tab-${1}`}
            aria-controls={`simple-tabpanel-${0}`}
          />
          <Tab
            label={tabs[1].label}
            id={`tab-${2}`}
            aria-controls={`simple-tabpanel-${1}`}
          />
        </Tabs>
      </div>
      <TabPanel
        value={activeTab}
        index={0}
        style={{ width: "100%", height: "100%" }}
      >
        <NativeFilter
          app={app}
          reference={{ id: tabs[0].id }}
          style={{ flex: 1, height: "100%" }}
        />
      </TabPanel>
      <TabPanel
        value={activeTab}
        index={1}
        style={{ width: "100%", height: "100%" }}
      >
        <NativeFilter
          app={app}
          reference={{ id: tabs[1].id }}
          style={{ flex: 1, height: "100%" }}
        />
      </TabPanel>
    </LayoutWrapper>
  );
}

export default ConjuntosBasket;

ConjuntosBasket.defaultProps = {
  app: null,
  config: {},
  index: 0,
};

ConjuntosBasket.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
  index: PropTypes.number,
};
